module.exports = __webpack_public_path__ + "static/media/dai.6a47d162.png";